// extracted by mini-css-extract-plugin
export default {"container":"login_container__yvKpF","remember":"login_remember__tPCey","buttons":"login_buttons__jGLY5"};